<template>
  <div>
    <div class="search-filters">
        <form class="form" @change="filterClosedGetResults()">
            <Date
                :data.sync="$props.filter.check_in_on"
                @track="$props.track"
                :icon="'#ico-cal'"
                :placeholder="'CHECK-IN DATE*'"
            />
            <Select
                :data.sync="$props.filter.minimum_nights"
                :options="options.night"
                :name="'Nights'"
                :classN="'dark'"
                :placeholder="'Nights'"
                :required="true"
                :icon="'#ico-night'"
                @track="$props.track"
            />
        </form>

        <button class="more" type="button" :class="{'open': showFilters}" @click.prevent="toggleFilters()">
          <svg class="ico">
            <use xlink:href="#ico-filt"></use>
          </svg>
          More filters
        </button>

        <HiddenFilters 
            :filter="$props.filter"
            :showFilters="showFilters"
            :options="options"
            :isMobile="$props.isMobile"
            :track="$props.track"
            @track="$props.track"
            @open="toggleFilters()"
            @getData="getResults()"
            @closeAndCancel="closeAndCancel()"
            
        />
    </div>
  </div>
</template>

<script>
import Select from 'shared/select.vue';
import Date from 'shared/date.vue';
import HiddenFilters from 'shared/hiddenFilters.vue';

export default {
  data: function () {
      return {
          options: {
              bedroom: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
              night: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
              guest: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
          },
          showFilters: false
      }
  },
  props: {
      filter: {
          type: Object,
          required: true
      },
      getData: Function,
      track: Function,
      isMobile: Boolean,
      formatActiveFilters: Function,
      pushSavedFilter: Function,
      savedFilter: Object
  },
  components: {
       Select, Date, HiddenFilters
  },
  methods: {
      trackFav: function(state) {
          this.$emit('track', "card_save_click_" + (state ? "favourite" : "unfavourite"));
      },
      getResults: function() {
          this.$emit('track', "auto_update_click");
          this.showFilters = false;
          this.$props.getData();
          this.$props.formatActiveFilters();
      },
      filterClosedGetResults() {
          if (!this.showFilters) {
              this.getResults();
          }
      },
      toggleFilters: function() {
          this.showFilters = !this.showFilters;
      },
      closeAndCancel: function() {
          let app = this;
          app.$props.pushSavedFilter();
          app.toggleFilters();
      }
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.search-filters {
   padding: 1.563rem 1.25rem;
   position: relative;
}

.box {
  position: relative;
  box-sizing: border-box;
  padding: 0 0.5rem 1rem 0;
  width: 50%;

  &:nth-child(2n) {
    padding: 0 0 1rem 0.5rem;
  }
}

.form {
  display: flex;
  flex-direction: row;
}

svg {
  left: .938rem;
  width: 1.25rem;
  position: absolute;
  height: 1.25rem;
  top: 50%;
  margin-top: -0.625rem;
}

.more {
  border: .125rem solid $col_bordergrey;
  background-color: #FAFAFA;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  border-radius: .3rem;
  height: 3.25rem;
  cursor: pointer;
  outline: none;
  font-size: .875rem;
  font-weight: 700;
  text-align: center;
  position: relative;
  text-transform: uppercase;

  svg {
    display:none;
  }

  &:focus {
    box-shadow: 0 0.125rem 1.25rem 0 $col_aqua;
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 1.25rem;
    transform: translateY(-50%);
    border-left: .375rem solid transparent;
    border-right: .375rem solid transparent;
    border-top: .375rem solid #000;
  }

  &.open {

    &:after {
      border-bottom: .375rem solid #000;
      border-top: none;
    }
  }
}

@media #{$desktop} {
  .box {
    padding: 0;
    margin-right: 1rem;
    width: auto;

    &:nth-child(2n) {
      padding: 0;
      width: auto;
    }
  }

  .more,
  .btn {
    width: 12rem;
  }

  .more {
    right: 1.25rem;
    top: 1.5rem;
    position: absolute;

    svg {
      left: .938rem;
      width: 1.25rem;
      position: absolute;
      height: 1.25rem;
      top: 50%;
      margin-top: -0.625rem;
      display: block;
    }
  }
}

</style>